<template>
  <span></span>
</template>
<script>
export default {
  mounted () {
    if (!window.name) {
      window.location = '/'
      return
    }
    if (this.$route.params.status || window.name !== 'dc_ag-' + this.$store.getters.$_checkAuth) {
      this.$store.dispatch('setNewTab', -1)
      window.close()
      return
    }
    this.$store.dispatch('setNewTab', false)
    window.close()
  }
}
</script>
